export enum ListUsersActionTypes {
  OPEN_LIST_USERS_MODAL = 'OPEN_LIST_USERS_MODAL',
  CLOSE_LIST_USERS_MODAL = 'CLOSE_LIST_USERS_MODAL',
  LIST_USERS_REQUEST = 'LIST_USERS_REQUEST',
  LIST_USERS_SUCCEEDED = 'LIST_USERS_SUCCEEDED',
  LIST_USERS_FAILED = 'LIST_USERS_FAILED',
}

export interface User {
  id: string;
  username: string;
  email: string;
  avatar: string;
  groupName: number;
  joinDate: number;
  status: any;
  phoneNumber: string;
  point: number;
  __typename: any;
}

export type resultType = {
  total: number;
  users: Array<object>;
};

export interface OpenListUsersModal {
  type: ListUsersActionTypes.OPEN_LIST_USERS_MODAL;
}

export interface CloseListUsersModal {
  type: ListUsersActionTypes.CLOSE_LIST_USERS_MODAL;
}

export interface ListUsersRequest {
  type: ListUsersActionTypes.LIST_USERS_REQUEST;
  input: object;
}

export interface ListUsersSucceeded {
  type: ListUsersActionTypes.LIST_USERS_SUCCEEDED;
  result: resultType;
}

export interface ListUsersFailed {
  type: ListUsersActionTypes.LIST_USERS_FAILED;
  error: string;
}

export type ListUsersActions =
  | OpenListUsersModal
  | CloseListUsersModal
  | ListUsersRequest
  | ListUsersSucceeded
  | ListUsersFailed;

export function openListUsersModal(): OpenListUsersModal {
  return {
    type: ListUsersActionTypes.OPEN_LIST_USERS_MODAL,
  };
}

export function closeListUsersModal(): CloseListUsersModal {
  return {
    type: ListUsersActionTypes.CLOSE_LIST_USERS_MODAL,
  };
}

export function listUsersRequest(input: object): ListUsersRequest {
  return {
    type: ListUsersActionTypes.LIST_USERS_REQUEST,
    input,
  };
}

export function listUsersSucceeded(result: resultType): ListUsersSucceeded {
  return {
    type: ListUsersActionTypes.LIST_USERS_SUCCEEDED,
    result,
  };
}

export function listUsersFailed(error: string): ListUsersFailed {
  return {
    type: ListUsersActionTypes.LIST_USERS_FAILED,
    error,
  };
}
